import jsCookie from 'js-cookie'
const queryParameterName = 'lastAmpAuthState'

// Returns the new url with our new query parameter.
function updateQueryStringParameter(uri, key, value) {
  if (!uri) return
  let re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i')
  let separator = uri && uri.indexOf('?') && uri.indexOf('?') !== -1 ? '&' : '?'
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + '=' + value + '$2')
  }
  return uri + separator + key + '=' + value
}

// Gets the value for for lastAmpAuthState from the cookie.
export const getLastAmpAuthState = function () {
  if (window.location.hostname === 'localhost') {
    jsCookie.set('lastAmpAuthState', 'unrecognized')
  }
  const lastAmpAuthState = jsCookie.get('lastAmpAuthState')
  return lastAmpAuthState || 'unrecognized'
}

export const getAdvisorLinkWithCookie = (url) => {
  const authState = getLastAmpAuthState()
  const update = updateQueryStringParameter(url, queryParameterName, authState)
  return update
}

